export default function GooglePlacesShadowStyler() {
	const attachShadow = Element.prototype.attachShadow;
	Element.prototype.attachShadow = function(init) {
	if (this.localName === "gmp-place-autocomplete") {
		const shadow = attachShadow.call(this, {
		...init,
		mode: "open"
		});

		const event = new CustomEvent('shadowroot:opened');
		document.dispatchEvent(event);

		const style = document.createElement("style");
		style.textContent = `

		.has-error input{
			border-color: red !important;
			background-color: red !important;
		}

		.clear-button{
			display: none !important;
		}
		.widget-container {
			padding: 14px 16px !important;
			border: none !important;
		}
		
		@media (max-width: 768px) {
			dialog.full-window-autocomplete-dialog {
				background-color: #fff !important;
			}
		}

		[role="presentation"]{
			display: none !important;
		}
		.input-container {
			display: flex;
			flex-direction: row-reverse !important;
		}
		.focus-ring {
			display: none !important;
		}
		.dropdown {
			--tw-bg-opacity: 1 !important;
			background-color: rgb(48 50 59 / var(--tw-bg-opacity)) !important;
			color: rgb(185 193 203 / var(--tw-text-opacity)) !important;
		}
		.place-autocomplete-element-place-icon {
			display: none !important;
		}
		.place-autocomplete-element-text-div {
			--tw-bg-opacity: 1 !important;
			color: rgb(185 193 203 / var(--tw-text-opacity)) !important;
		}
		.place-autocomplete-element-place-name {
			--tw-bg-opacity: 1 !important;
			color: rgb(185 193 203 / var(--tw-text-opacity)) !important;
		}
		.place-autocomplete-element-place-details {
			--tw-bg-opacity: 1 !important;
			color: rgb(185 193 203 / var(--tw-text-opacity)) !important;
		}
		.place-autocomplete-element-place-result--matched {
			--tw-bg-opacity: 1 !important;
			color: rgb(255 178 135 / var(--tw-text-opacity)) !important;
		}
		ul {
			background-color: white !important;
			color: #000 !important;
		}
		li {
			margin: 5px !important;
			border: none !important;
			border-radius: 5px !important;
			min-height: 50px !important;
		}
		li:hover {
			cursor: pointer !important;
			background-color: rgba(196, 196, 196, 1) !important;
		}
		input {
			font-size: 14px;
			--tw-text-opacity: 1;
			color: rgb(0 0 0 / var(--tw-text-opacity));
			background-color: transparent;
			padding: 0 !important;
		}
		input.forced-focus {
			padding-top: 11px !important;
		}
		`;
		shadow.appendChild(style);

		return shadow;
	}
	return attachShadow.call(this, init);
	};
}